import { request } from './http';
import { SignInResult } from './types';

export const signUp = (body: {
  email: string;
  password: string;
  name?: string;
}) =>
  request<{ message: string; email: string }, typeof body>(
    '/auth/signup',
    'POST',
    body,
  );

/**
 * Browsers get HttpOnly cookies and no tokens in the body. `mode: 'token'` is
 * for native clients that cannot use cookies.
 *
 * A 401 here means wrong credentials, not an expired session, so the global
 * unauthorized handler is skipped.
 */
export const signIn = (body: {
  email: string;
  password: string;
  mode?: 'token';
}) =>
  request<SignInResult, typeof body>('/auth/signin', 'POST', body, {
    skipUnauthorizedHandler: true,
  });

export const signOut = () =>
  request<{ message: string }>('/auth/signout', 'POST', undefined, {
    skipUnauthorizedHandler: true,
  });

export const confirmSignUp = (body: { email: string; code: string }) =>
  request<{ message: string }, typeof body>('/auth/confirm', 'POST', body);

export const resendConfirmation = (body: { email: string }) =>
  request<{ message: string }, typeof body>(
    '/auth/resend-confirmation',
    'POST',
    body,
  );

/** Always resolves, whether or not the address has an account. */
export const forgotPassword = (body: { email: string }) =>
  request<{ message: string }, typeof body>(
    '/auth/forgot-password',
    'POST',
    body,
  );

export const confirmForgotPassword = (body: {
  email: string;
  code: string;
  password: string;
}) =>
  request<{ message: string }, typeof body>(
    '/auth/confirm-forgot-password',
    'POST',
    body,
  );

export const refreshSession = () =>
  request<{ message: string }>('/auth/refresh', 'POST', undefined, {
    skipUnauthorizedHandler: true,
  });

export const health = () =>
  request<{ status: string; stage: string }>('/health', 'GET');
